@if (label) {
  <div class="mb-2">
    <span class="font-semibold" data-test-id="service-provider-search-label">{{ label }}</span>
  </div>
}

<form [formGroup]="searchForm">
  <div class="flex mb-2">
    <label class="label field-required" data-test-id="npi-label">Search Service Provider by NPI:</label>
  </div>
  <div class="flex gap-4">
    <p-input-mask
      slotChar=""
      mask="999999999999"
      [maxlength]="12"
      formControlName="searchText"
      placeholder="Enter the NPI"
      [autoClear]="false"
      data-test-id="npi-value"
    ></p-input-mask>
    <button
      pButton
      type="submit"
      label="Search"
      icon="pi pi-search"
      [loading]="isLoading"
      (click)="searchNPI()"
      [disabled]="!searchForm.valid"
      data-test-id="npi-search-button"
    ></button>
    @if(isProviderNotFound && isHhAuthForPacUser && showAddBtn) {
      <p-divider layout="vertical" />
      <button
        pButton
        type="button"
        label="Add New Provider"
        icon="pi pi-plus" 
        class="p-button p-button-secondary" 
        (click)="addNewProvider()"
        data-test-id="add-new-provider"
      ></button>
    }
  </div>
  
  @if (isProviderNotFound) {
    @if(isHhAuthForPacUser) {
      <div>
        <p class="font-semibold py-2">
          Service provider not found.
        </p>
        <p>
          Make sure that you have entered the correct NPI and try again, or add new provider details.
        </p>
      </div>
    } @else {
      <div class="mb-4">
        <p class="text-red-400 font-semibold py-4" data-test-id="npi-search-error">
          Service Provider Not found.
        </p>
      </div>
      @if (isProviderNotFound && authRequest) {
        <div class="mt-4">
          <div class="flex items-center">
            <p-checkbox
              inputId="npiNotFoundCheck"
              binary="true"
              (onChange)="updateStatus($event)"
              [formControl]="npiCheck"
              data-test-id="npi-not-found-checkbox"
            ></p-checkbox>
            <label for="npiNotFoundCheck" class="ml-2">NPI was not found. Click checkbox and enter service location to continue.</label>
          </div>
        </div>
      }
    }
  }
</form>
